<nz-select
  nzShowSearch
  nzServerSearch
  [nzAllowClear]="true"
  [nzBackdrop]="addBackdrop"
  [nzFilterOption]="nzFilterOption"
  (nzOnSearch)="search($event)"
  (nzOpenChange)="search('')"
  (nzScrollToBottom)="loadMore()"
  [nzCustomTemplate]="displayTpl"
  [(ngModel)]="value"
  (ngModelChange)="valueChanged($event)"
  [nzDropdownMatchSelectWidth]="false"
  [nzBorderless]="borderless"
  nzDropdownClassName="dropdownSelect"
  class="width-100"
>
  <ng-template #displayTpl let-selected>
    {{ selected.nzLabel }}
  </ng-template>
  <ng-container *ngFor="let o of list">
    <nz-option *ngIf="!searching" [nzValue]="o" [nzLabel]="o.docCode" nzCustomContent>
      <div class="width-lg max-width-xl">
        <div>
          <div class="code-container-width">
            <strong>{{ o.docCode }}</strong>
            <small class="float-right" 
              [class.label-found]="o.matchType != 1" 
              [class.label-not-found]="o.matchType == 1">
              @if (o.matchType != 1) { MATCHED }
              @else { OTHERS }
            </small>
          </div>
        </div>
        <div>
          <small>{{ o.description }}</small>
        </div>
        <div>
          <small>{{ o.docDate | customDate }}</small>
          <small class="float-right" style="font-size: 13px">
            <b>{{ o.amount | currencyWithSpace: o.currencyCode }}</b>
          </small>
        </div>
        <nz-divider class="m-none"></nz-divider>
      </div>
    </nz-option>
  </ng-container>
</nz-select>
<ng-template #loadingTpl>
  <div *ngIf="searching">
    <nz-spin></nz-spin>
    Loading
  </div>
</ng-template>
